import { recordSyncAction, recordSyncIssue } from "../domain/syncIssue";

function hasPendingData(record, status) {
  return Boolean(record?.pending || status?.pendingCount > 0);
}

// `signInRequired`: a local recovery shell with an anonymous bootstrap (Phase 8,
// §10.2). Informational only, at the existing "Sign in to sync" precedence.
export function resolveSyncLabel({ online, readOnly, record, status, signInRequired = false }) {
  if (readOnly) return "Open in another tab";
  // A non-retryable failure or a rejected write stays visible whatever the
  // connection: waiting will not sync it.
  if (recordSyncIssue(record)) return "Sync issue";
  if (!online) return hasPendingData(record, status) ? "Saved on device" : "Offline";
  const action = recordSyncAction(record);
  if (signInRequired || action === "SIGN_IN") return "Sign in to sync";
  if (action === "UPDATE") return "Needs update";
  // Only while a push request for this execution is actually in flight.
  if (record?.pending && status?.syncingExecutionIds?.includes(record.executionId)) {
    return "Syncing";
  }
  if (hasPendingData(record, status)) return "Saved on device";
  return "Synced";
}

// Status only: chip styling without the design-system Chip's button/toggle
// semantics. Not a live region, so routine Syncing/Synced flips stay silent;
// an issue is explained by the nearby SyncIssueNotice.
export default function SyncStatusChip(props) {
  const label = resolveSyncLabel(props);
  return (
    <span
      className="lz-v2-chip lz-workout-sync-chip"
      data-issue={label === "Sync issue" || undefined}
    >
      {label}
    </span>
  );
}
